import React, { useState, useContext, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { AuthContext } from "../context/authContext";

const Write = () => {
  const { currentUser } = useContext(AuthContext);
  const state = useLocation().state;
const [value, setValue] = useState(state?.desc || "");
  const [title, setTitle] = useState(state?.title || "");
  const [file, setFile] = useState(null);
  const [drafts, setDrafts] = useState([]);
  const [editingDraft, setEditingDraft] = useState(state || null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDrafts = async () => {
      try {
        const res = await axios.get("/api/posts/drafts");
        setDrafts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDrafts();
  }, []);

  const upload = async () => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("/api/upload", formData);
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const savePost = async (status) => {
    const imgUrl = file ? await upload() : "";

    try {
      editingDraft
        ? await axios.put(`/api/posts/${editingDraft.id}`, {
            title,
            desc: value,
            cat: "general",
            img: file ? imgUrl : editingDraft.img,
            status,
          })
        : await axios.post(`/api/posts/`, {
            title,
            desc: value,
            cat: "general",
            img: imgUrl,
            date: moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
            status,
          });

      navigate(status === "draft" ? "/drafts" : "/posts");
    } catch (err) {
      console.log(err);
    }
  };

  if (currentUser?.username !== "emma20106") {
    return <div className="add"><h2>Sorry, only the blog owner can write posts!</h2></div>;
  }

  return (
    <div className="add">
      <div className="content">
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <div className="editor-container">
          <ReactQuill
            className="editor"
            theme="snow"
            value={value}
            onChange={setValue}
          />
        </div>
      </div>
      <div className="menu">
        <div className="item">
          <h1>Publish</h1>
          <input
            style={{ display: "none" }}
            type="file"
            id="file"
            name=""
            onChange={(e) => setFile(e.target.files[0])}
          />
          <label className="file" htmlFor="file">
            Upload Image
          </label>
          <div className="buttons">
            <button onClick={() => savePost("draft")}>Save as a draft</button>
            <button onClick={() => savePost("published")}>Publish</button>
          </div>
        </div>

        <div className="item">
          <h1>Drafts</h1>
          {drafts.length === 0 ? (
            <p style={{ fontSize: "12px", color: "#555" }}>No drafts yet.</p>
          ) : (
<div className="drafts-list">
              {drafts.map((draft) => (
                <div key={draft.id} className="draft-item-row">
                  <span
                    className="draft-item"
                    onClick={() => {
                      setEditingDraft(draft);
                      setTitle(draft.title || "");
                      setValue(draft.desc || "");
                    }}
                  >
                    {draft.title || "(untitled)"}
                  </span>
                  <span
                    className="draft-delete"
                    onClick={async () => {
                      await axios.delete(`/api/posts/${draft.id}`);
                      setDrafts(drafts.filter((d) => d.id !== draft.id));
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Write;
